var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.25 9.87v1.75a1.166 1.166 0 0 1-1.272 1.167 11.545 11.545 0 0 1-5.034-1.791 11.375 11.375 0 0 1-3.5-3.5 11.544 11.544 0 0 1-1.79-5.058 1.167 1.167 0 0 1 1.16-1.271h1.75A1.167 1.167 0 0 1 4.731 2.17c.074.56.21 1.11.408 1.64.16.425.058.906-.262 1.23l-.741.74a9.333 9.333 0 0 0 3.5 3.5l.74-.74c.324-.32.805-.423 1.231-.263.53.198 1.08.335 1.64.409A1.167 1.167 0 0 1 12.25 9.87Z",
    clipRule: "evenodd"
  })));
};
export default SvgPhone;